import abstractModel from '../../core/MercatelyModel';

const BASE_URL = `${ENV.DEAL_ENGINE_BASE_URL}`
const RESOURCE = `${BASE_URL}/funnels/`;

const model = abstractModel(RESOURCE);

model.getExportedFunnels = async (params) => {
  const newResource = `${BASE_URL}/exported_funnels?page=${params.page}`;

  return model.get({}, { path: newResource });
};

// TODO: Move the old request to call this new abstractModel function
model.getWithAutomations = async (params) => {
  const newResource = `${RESOURCE}/${params.web_id}/with_automations`;

  return model.get({}, { path: newResource });
};

model.createFromTemplate = async (params) => {
  const newResource = `${BASE_URL}/v2/funnels/create_from_template`;

  return model.save(params, { path: newResource });
};

model.create = async (params) => {
  const newResource = `${BASE_URL}/v2/funnels/`;

  return model.save(params, { path: newResource });
};

export default model;
